// extracted by mini-css-extract-plugin
export default {"disclaimerInfo":"styles_disclaimerInfo__2Q8+6"};